import axios from 'axios'
import qs from 'qs'; //注：qs，使用axios，必须得安装 qs，所有的Post 请求，我们都需要 qs,对参数进行序列化。
import {Message} from 'view-design';
import router from './../router';
axios.defaults.timeout = 4500000;
axios.defaults.withCredentials = true;
/**
 * 请求拦截器的作用是在请求发送前进行一些操作，例如在每个请求体里加上token，
 * 统一做了处理如果以后要改也非常容易。
 *
 */
axios.interceptors.request.use(config => {
  const loginToken =window.sessionStorage.getItem('loginToken');

  // 判断是否存在token，如果存在的话，则每个http header都加上token
  if(loginToken){
    config.headers['Access-Token'] = loginToken; // 让每个请求携带自定义 token 请根据实际情况自行修改
  }

  // 序列化
  // config.data = qs.stringify(config.data);
  // config.data = JSON.stringify(config.data);
  // 若是提交能直接接受json 格式,可以不用 qs 来序列化的
  //console.log(config);
  config.data = qs.stringify(config.data);//序列化
  return config;
}, error => {
  // 对请求错误做些什么，自己定义
  Message.error({
    content:error, //提示内容
    closable:true  //是否显示关闭按钮
  });
  return Promise.reject(error);// 错误提示
})


/**
 * 响应拦截器的作用是在接收到响应后进行一些操作，例如在服务器返回登录状态失效，需要重新登录的时候，跳转到登录页等。
 * */
axios.interceptors.response.use(response => {
    //console.log(response);
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response.data);
    }
  },
  error => {
    //console.log(JSON.stringify(error.response)) // for debug
    //console.log(error.response.data.message);
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          Message.error({
            content: '登录过期，请重新登录',
            duration: 10,
            closable: true
          });
          // 清除token
          localStorage.removeItem('Access-Token');
          store.commit('setLoginToken', null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;

        // 404请求不存在
        case 404:
          Message.error({
            content: '网络请求不存在',
            duration: 10,
            closable: true
          });
          break;
        case 500:
          Message.error({
            content: error.response.data.message,
            duration: 10,
            closable: true
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          Message.error({
            content: error.response.data.message,
            duration: 10,
            closable: true
          });
      }
      return Promise.reject(error.response);
    }
  }
);

export default axios
